.previewContainer {
  display: flex;
  justify-content: start;
  gap: 0.5em;
  margin-top: 0.5em;
}

.sideLayout {
  display: grid;
  grid-template-columns: minmax(0, 4.5fr) minmax(150px, 1fr);
  gap: 0.5rem;
  aspect-ratio: 2.1;
  min-height: 0;
  overflow: hidden;
}

.sideCarousel {
  min-width: 0;
  min-height: 0;
  height: 100%;
}

.sideLayout :global(.mantine-Carousel-root) {
  height: 100%;
  min-height: 0;
}

.sideLayout :global(.mantine-Carousel-viewport),
.sideLayout :global(.mantine-Carousel-container),
.sideLayout :global(.mantine-Carousel-slide) {
  height: 100%;
  min-height: 0;
}

.sideLayout :global(.mantine-Carousel-slide) > div {
  height: 100%;
}

.sideLayout :global(.mantine-Carousel-indicators) {
  display: none;
}

.sideLayout .mainImage {
  height: 100%;
  min-height: 0;
}

.sidePreviewContainer {
  display: grid;
  grid-template-rows: repeat(4, minmax(0, 1fr));
  height: 100%;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  gap: 0.5rem;
}

.sidePreviewImage,
.sidePreviewContainer .moreImages {
  min-height: 0;
  height: 100%;
  width: 100%;
  object-fit: cover;
  cursor: pointer;
  opacity: 1;
  transition: opacity 0.2s ease;
}

.sidePreviewImage:hover,
.sidePreviewContainer .moreImages:hover {
  opacity: 0.9;
}

.sidePreviewSlot {
  min-height: 0;
  overflow: hidden;
}

.previewImage {
  flex: 1;
  min-width: 0;
  height: 85px;
  object-fit: cover;
  border-radius: 4px;
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.previewImage:hover {
  opacity: 1;
}

.activePreview {
  opacity: 1;
  border: 2px solid var(--mantine-primary-color-9);
}

.moreImages {
  flex: 1;
  min-width: 0;
  height: 85px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: light-dark(var(--mantine-primary-color-1), var(--mantine-color-primaryDark-7));
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
  font-weight: bold;
  color: light-dark(var(--mantine-primary-color-1), var(--mantine-color-primary-2));
  padding: 0.5rem;
  text-align: center;
}

.moreImageBackground {
  position: absolute;
  inset: 0;
  height: 100% !important;
  width: 100% !important;
  object-fit: cover;
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.moreImages:hover .moreImageBackground {
  opacity: 1;
}

.moreImages::before {
  position: absolute;
  inset: 0;
  z-index: 1;
  background: light-dark(
    linear-gradient(0deg, rgb(0, 0, 0, 0.6) 0%, rgb(0, 0, 0, 0.6) 100%),
    linear-gradient(135deg, #38383eb8 0%, #202127cb 100%)
  );
  content: "";
  pointer-events: none;
}

.moreImages :global(.mantine-Text-root) {
  position: relative;
  z-index: 2;
}

.mainImage {
  width: 100%;
  height: 500px;
  user-select: none;
  touch-action: none;
}

.mantineModalTitle {
  font-size: 1.25em;
}

.galleryModalContent {
  display: flex;
  flex-direction: column;
  min-height: 0;
  background: #151515;
  color: #fff;
}

.galleryModalHeader {
  position: relative;
  background: #151515;
  color: #fff;
}

.galleryModalHeader :global(.mantine-Modal-close) {
  color: #fff !important;
  opacity: 1;
  visibility: visible;
}

.galleryModalHeader :global(.mantine-Modal-close:hover) {
  background-color: #728ad012;
}

.galleryModalHeader :global(.mantine-Modal-close svg) {
  color: #fff !important;
}

.galleryUploadButton {
  position: absolute;
  right: 56px;
  top: 50%;
  transform: translateY(-50%);
}

.galleryModalBody {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
  padding: 0 1rem 1rem;
  box-sizing: border-box;
}

.galleryModal {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  gap: 1rem;
  min-height: 0;
}

.galleryCounter {
  color: #fff;
  font-size: 0.8rem;
  font-weight: 700;
}

.galleryThumbnailStrip {
  flex: 0 0 auto;
  width: 100%;
  min-width: 0;
  justify-content: center;
  overflow-x: hidden;
  overflow-y: hidden;
  padding: 0 0 0.5rem;
  scrollbar-width: thin;
}

.galleryThumbnailStrip :global(.mantine-Carousel-container) {
  justify-content: safe center;
}

.galleryThumbnail {
  flex: 0 0 110px;
  height: 78px;
  cursor: pointer;
  opacity: 0.75;
  overflow: hidden;
  border: 2px solid transparent;
  border-radius: var(--mantine-radius-sm);
}

.galleryModalImage {
  flex: 1 1 0;
  min-height: 0;
  position: relative;
  height: auto;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.galleryDeleteButton {
  position: absolute;
  top: 1rem;
  right: 1rem;
  opacity: 0.8;
  z-index: 3;
}

.galleryDeleteButton:hover {
  opacity: 0.9;
}

.galleryModalImageContent {
  position: relative;
  height: 100%;
  max-width: 100%;
  min-width: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.galleryModalImageContent :global(img) {
  display: block;
  height: 100% !important;
  width: auto !important;
  max-width: 100%;
  margin: 0 !important;
  object-fit: contain;
}

.galleryThumbnailStrip {
  flex: 0 0 auto;
  width: 100%;
  min-width: 0;
  justify-content: center;
  overflow-x: hidden;
  overflow-y: hidden;
  padding: 0 0 0.5rem;
  scrollbar-width: thin;
}

.galleryThumbnail {
  flex: 0 0 110px;
  height: 78px;
  cursor: pointer;
  opacity: 0.75;
  overflow: hidden;
  border: 2px solid transparent;
  border-radius: var(--mantine-radius-sm);
}

.galleryThumbnail:hover,
.galleryThumbnailActive {
  border-color: var(--mantine-color-primary-7);
  opacity: 1;
}

.galleryThumbnail :global(img) {
  display: block;
  height: 100%;
  width: 100%;
  object-fit: cover;
}

@media (max-width: 48em) {
  .sideLayout {
    display: flex;
    flex-direction: column;
    aspect-ratio: auto;
    gap: 0.5rem;
    overflow: visible;
  }

  .sideCarousel {
    height: auto;
    aspect-ratio: 1.73;
  }

  .sidePreviewContainer {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    grid-template-rows: none;
    height: 85px;
    overflow: visible;
  }

  .galleryModalBody {
    padding: 0 0.75rem 0.75rem;
  }

  .galleryModal {
    min-height: 0;
  }

  .galleryModalImage {
    height: auto;
    min-height: 0;
  }

  .galleryThumbnail {
    flex-basis: 96px;
    height: 68px;
  }
}
